export function deepclone(obj: any) {
    return JSON.parse(JSON.stringify(obj));
}